import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PhxRadioListBackground, PhxRadioListSize, PhxRadioValue } from './phx-radio-list.types';

@Injectable()
export class PhxRadioListService {
  selected$ = new BehaviorSubject<PhxRadioValue>('');
  disabled$ = new BehaviorSubject<boolean>(false);
  background$ = new BehaviorSubject<PhxRadioListBackground>('standard');
  size$ = new BehaviorSubject<PhxRadioListSize>('medium');
  internalSelection$ = new BehaviorSubject<PhxRadioValue | null>(null);

  select(value: PhxRadioValue): void {
    this.selected$.next(value);
  }

  selectInternal(value: PhxRadioValue): void {
    this.internalSelection$.next(value);
    this.selected$.next(value);
  }

  setDisabled(value: boolean): void {
    this.disabled$.next(value);
  }

  setBackground(value: PhxRadioListBackground): void {
    this.background$.next(value);
  }

  setSize(value: PhxRadioListSize): void {
    this.size$.next(value);
  }
}
